import React from 'react';
import YouTubePopular from '../components/YouTubePopular';

const YouTubePage = () => {
  return <YouTubePopular />;
};

export default YouTubePage;